import React from "react";
import {
  RecipientPotentiallyUnknownOrg,
  RecipientUser,
} from "../../../../../domain/RecipientsViewModel";
import { List } from "@material-ui/core";
import { OrgAction } from "./reducer";
import { ManageRecipientUser } from "./ManageRecipientUser";

type ManageRecipientUsersProps = {
  org: RecipientPotentiallyUnknownOrg;
  users: RecipientUser[];
  dispatch: React.Dispatch<OrgAction>;
};

export const ManageRecipientUsers: React.FC<ManageRecipientUsersProps> = ({
  org,
  users,
  dispatch,
}) => {
  return (
    <List disablePadding>
      {users.map((user) => (
        <ManageRecipientUser
          key={user.id}
          org={org}
          user={user}
          dispatch={dispatch}
        />
      ))}
    </List>
  );
};
